import React from "react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { Backdrop, Button, Box, Chip, CircularProgress, Container, Typography, TextField, Stack } from "@mui/material";
import SumupPayWidget from '../components/ui/SumupPayWidget';
import { Context } from "../App";
import {v4 as uuid} from 'uuid';
import BilletInfoSection from "../components/sections/BilletInfoSection";
import { Link, useNavigate } from "react-router-dom";

export default function Panier(){
    const navigate = useNavigate()
    const { userId, setUserId, isConnected, setIsConnected } = React.useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [panier, setPanier] = React.useState()
    const [events, setEvents] = React.useState([]);
    const [checkoutId, setCheckoutId] = React.useState(null);
    const [codePromo, setCodePromo] = React.useState('');
    const [promo, setPromo] = React.useState(null);
    const [promos, setPromos] = React.useState([]);

    const autoPromos = React.useMemo(() => {
        if (!panier?.items?.length || !promos.length) return [];
        return promos.filter(p => !p.code).filter(p => {
            if (!p.isActive) return false;
            if (typeof p.limite === 'number' && p.usage >= p.limite) return false;
            if (p.users?.length > 0 && (!isConnected || !p.users.some(u => u === userId))) return false;
            const relatedItems = panier.items.filter(item =>
                item.id?.collectionName !== 'Don' && p.events.some(e => e === item.id?.event)
            );
            if (relatedItems.length === 0) return false;
            return (p.conditions || []).every(cond => {
                if (cond.type === 'min_billets') return relatedItems.reduce((acc, i) => acc + i.quantity, 0) >= cond.valeur;
                if (cond.type === 'min_montant') return relatedItems.reduce((acc, i) => acc + i.id.price * i.quantity, 0) >= cond.valeur;
                if (cond.type === 'min_prix_billet') return relatedItems.some(i => i.id.price >= cond.valeur);
                return true;
            });
        });
    }, [promos, panier, isConnected, userId]);

    function getItemTotal(item) {
        if (item.collectionName === 'Don') {
            return item.dime + item.offrande_globale +
                [...item.offrande_spe_feam, ...item.offrande_spe_eglise, ...item.projets].reduce((acc, curr) => acc + curr.montant, 0);
        }
        let price = item.price;
        if (promo && promo.events.some(e => e === item.event)) {
            const reduction = promo.isPercentage ? (price * promo.reduction / 100) : promo.reduction;
            price = Math.max(0, price - reduction);
        }
        for (const ap of autoPromos) {
            if (!ap.events.some(e => e === item.event)) continue;
            if ((ap.conditions || []).some(c => c.type === 'min_prix_billet' && item.price < c.valeur)) continue;
            const reduction = ap.isPercentage ? (price * ap.reduction / 100) : ap.reduction;
            price = Math.max(0, price - reduction);
        }
        return price;
    }
    const total = React.useMemo(() => panier?.items.reduce((acc, item) => acc + (getItemTotal(item.id) * item.quantity), 0), [panier, promo, autoPromos]);

    function handlePromo() {
        const query = new URLSearchParams({code: codePromo}).toString();
        fetch(`${process.env.REACT_APP_API_URL}/promos?${query}`, {
            method: 'GET',
            headers: { 
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        })
        .then(res => res.json())
        .then(data => {
            const promotion = data[0] || null;
            if (promotion) {
                if(!promotion.isActive || (typeof promotion.limite === 'number' && promotion.usage >= promotion.limite)) {
                    alert("Code promo invalide.");
                    setPromo(null);
                    return;
                }
                if (promotion.users?.length > 0){
                    if(!isConnected) {
                        alert("Vous devez être connecté pour utiliser ce code promo.");
                        setPromo(null);
                        return;
                    } else if (!promotion.users.some(user => user === userId)) {
                        alert("Vous n'êtes pas autorisé à utiliser ce code promo.");
                        setPromo(null);
                        return;
                    }
                }
                setPromo(promotion);
            }
        })
        .catch(err => {
            console.error("Error fetching promo:", err);
        });
    }
    

    React.useEffect(()=>{
        let token = localStorage.getItem('token')?? userId;
        if (!token) {
            let userId = localStorage.getItem('anonUserId');
            if (!userId) {
                userId = uuid();
                localStorage.setItem('anonUserId', userId);
            }
            setUserId(userId); token = userId;
        }

        setLoad(true);
        fetch(process.env.REACT_APP_API_URL.concat('/panier/by/owner'), {method: 'GET', 
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
        .then((res) => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            return res.json()
        }).then((data) => { 
            setPanier(data.panier);
            setEvents(data.events);
            setLoad(false);
        }).catch((err) => {
            console.error("Error fetching panier:", err);
            setLoad(false);
        });
    }, [userId])

    React.useEffect(()=>{
        if(events.length > 0) {
            setLoad(true);
            fetch(process.env.REACT_APP_API_URL.concat('/promos'), {method: 'POST', 
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }, body: JSON.stringify({events: events.map(e=>e._id)})
            })
            .then((res) => {
                const token = res.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                return res.json()
            }).then((data) => { 
                setPromos(data); console.log('Fetched promos:', data);
                setLoad(false);
            }).catch((err) => {
                console.error("Error fetching promos:", err);
                setLoad(false);
            });
        }
    }, [events])

    React.useEffect(() => {}, [panier]);

    function CreatePaiement() {
        setLoad(true)
        const query = new URLSearchParams({panier: panier._id}).toString();
        fetch(`${process.env.REACT_APP_API_URL}/stripe/checkout?${query}`, {
            method: 'POST',
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            },
            body: JSON.stringify({
                codePromo: (promo?._id || null),
                autoPromos: autoPromos.map(p => p._id)
            })
        }).then(res => {
            const token = res.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if(res.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                setIsConnected(false); setLoad(false)
            }
            if (!res.ok) {
                throw new Error('Failed to create Stripe session');
            }
            return res.json();
        })
        .then(data => {
            window.location.href = data.url; // redirection vers Stripe
        }).catch((err) => {
            console.error("Error during payment:", err);
            setLoad(false);
        });
    }

    function handleValide() {
        if (total > 0) {
            CreatePaiement();
        } else {
            setLoad(true)
            const query = new URLSearchParams({_id: panier._id}).toString();
            fetch(`${process.env.REACT_APP_API_URL}/panier/free/validate?${query}`, {
                method: 'PATCH',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                body: JSON.stringify({
                    autoPromos: autoPromos.map(p => p._id)
                })
            }).then(res => {
                const token = res.headers.get('x-auth-token');
                if (token) localStorage.setItem('token', token);
                if(res.status === 401) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('user');
                    setIsConnected(false); setLoad(false)
                }
                if (!res.ok) {
                    const msg = res.text();
                    if (msg) alert(msg);
                    throw new Error('Failed to validate panier');
                }
                return res.json();
            }).then(data => {
                setLoad(false);
                navigate('/mes_billets');
            }).catch((err) => {
                console.error("Error validating panier:", err);
                setLoad(false);
            });
        }
    }

    //     fetch(process.env.REACT_APP_API_URL.concat('/payment/sumup'), {method: 'POST', 
    //         headers: {
    //             'Content-Type': 'application/json',
    //             'Authorization': `Bearer ${localStorage.getItem('token')}`
    //         }, 
    //         body: JSON.stringify({
    //             amount: total, 
    //             currency: 'EUR', 
    //             description:'MGP- '+events.map(e=>e.titre).join(' - '), 
    //             panierId: panier._id})
    //     }).then((res) => {
    //         const token = res.headers.get('x-auth-token');
    //         if (token) localStorage.setItem('token', token);
    //         return res.json()
    //     }).then((data) => {
    //         if (data) {
    //             setCheckoutId(data)
    //         }
    //         setLoad(false);
    //     }).catch((err) => {
    //         console.error("Error during payment:", err);
    //         setLoad(false);
    //     });
    // }
    
    return(
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Container maxWidth="sm" sx={{ my: 4, minWidth: { xs: 'auto', sm: '500px' }, display:'flex', flexDirection:'column', px: { xs: 2, sm: 3 } }}>
                <Typography variant="h1" sx={{ fontSize: { xs: '2rem', sm: '2.5rem' } }}>Mon panier</Typography>

                {panier?.items.length <= 0 ? 
                    <Typography variant="subtitle1" sx={{my:2, fontSize: { xs: '0.9rem', sm: '1rem' }}}>
                        <span style={{fontWeight:'bold', fontSize: 18}}>Votre panier est vide.</span><br/><br/>Vous pouvez ajouter des articles à votre panier depuis les pages d'évènement.<br/>
                    </Typography>
                :
                    panier?.items.map((item, index) => item.collectionName === 'Billet' ? 
                        <BilletInfoSection key={index} billet={item.id} setLoad={setLoad} setPanier={setPanier} rmBillet={()=>setPanier(old=> ({...old, items: old.items.filter(i => i.id._id !== item.id._id)}))} />
                        : null
                )}

                {autoPromos.map((ap, i) => (
                    <Box key={i} sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1, px: 1, py: 0.5, borderRadius: 1, bgcolor: 'success.light' }}>
                        <Chip label="Promo auto" size="small" color="success" />
                        <Typography variant="body2" sx={{ fontWeight: 'bold', flex: 1 }}>{ap.titre}</Typography>
                        <Typography variant="body2" color="success.dark">
                            -{ap.isPercentage ? `${ap.reduction}%` : `${ap.reduction.toFixed(2)} €`} par billet
                        </Typography>
                    </Box>
                ))}

                {/* code promo */}
                {panier?.items.length > 0 && <Stack>
                    <TextField label="Code promo" variant="outlined" size="small" sx={{width:'100%', my:2}} value={codePromo} onChange={(e) => setCodePromo(e.target.value)} />
                    <Button variant="outlined" color="validation.main" size="large" onClick={handlePromo}
                    sx={{alignSelf:'center', px: { xs: 3, sm: 5 }, mb:2, borderWidth:3, py: { xs: 1, sm: 1.5 }, fontSize: { xs: '0.9rem', sm: '1rem' }}} >
                        Appliquer le code promo
                    </Button>
                </Stack>}

                {total>0 && <Typography variant="h2" sx={{mt:2, mb:1, fontSize: { xs: '1.5rem', sm: '2rem' }}}>
                    Total : <span style={{color:'var(--mui-palette-primary-main)'}}>{total.toFixed(2)} €</span>
                </Typography>}
                
                {!isConnected && <Typography variant="subtitle1" sx={{my:2, fontStyle:'italic', color:'alerte.main', fontSize: { xs: '0.875rem', sm: '1rem' }}}>
                    Vous devez être connecté pour valider votre panier. Connectez-vous ou créez un compte <Link to="/connexion" color="focus2" >ici</Link>.
                </Typography>}

                {!!panier && <Button variant="outlined" color="validation.main" size="large" onClick={handleValide} disabled={panier.items.length<=0||!isConnected || panier.items.some(el=> !!!el.id.owner?.nom || !!!el.id.owner?.prenom||events.some(e=> e.tarifs.some(t=> t.tickets_restants === 0 && panier.items.some(i=>i.tarif === t.nom && i.price===t.montant))))} sx={{alignSelf:'center', px: { xs: 3, sm: 5 }, mb:2, borderWidth:3, py: { xs: 1, sm: 1.5 }, fontSize: { xs: '0.9rem', sm: '1rem' }}} >
                    Valider mon panier
                </Button>}

                <Typography variant="subtitle1" sx={{my:2, color:'primary', textAlign:'right', fontWeight:'bold', cursor:'pointer', fontSize: { xs: '0.875rem', sm: '1rem' }}} onClick={()=>navigate('/billeterie')}>
                    Poursuivre mes achats
                </Typography>
                
                <SumupPayWidget {...{checkoutId, total, handleResponse:()=>{setLoad(true); setTimeout(() => {
                    navigate('/paiement/status/' + checkoutId);
                }, 3500);}}} />
            </Container>
            <Backdrop open={load}><CircularProgress/></Backdrop>
            <Footer />
        </Box>
    )
} 